import React, { useState, Suspense } from "react";
import { Layout } from "antd";
import preval from "preval.macro";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { GlobalProvider } from "./components/GlobalContext";
import MainMenu from "./components/MainMenu";
import Toolbar from "./components/Toolbar";

import Profile from "./components/Profile";
import Mods from "./components/Mods";
import ScoresEnso from "./components/ScoresEnso";
import ScoresAi from "./components/ScoresAi";

import "./assets/fonts/index.scss";
import "antd/dist/antd.min.css";

const Favorites = React.lazy(() => import("./components/Favorites"));

function App() {
    const { Sider, Content } = Layout;
    const [collapsed, setCollapsed] = useState(false);

    const buildDate = preval`module.exports = new Date();`;

    const onCollapse = (collapsed) => {
        setCollapsed(collapsed);
    };

    const getBuildDateTimeString = () => {
        return `Last Updated: ${new Date(buildDate).toLocaleDateString(
            "en-US",
            {
                year: "numeric",
                month: "long",
                day: "numeric",
            }
        )} at ${new Date(buildDate).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
        })}`;
    };

    const FavoritesRoute = () => (
        <Suspense fallback={<div>Loading...</div>}>
            <Favorites />
        </Suspense>
    );

    return (
        <div className="App">
            <Router>
                <Layout
                    style={{
                        height: `100vh`,
                    }}
                >
                    <GlobalProvider>
                        <Toolbar />
                        <Layout>
                            <Sider
                                collapsible
                                collapsed={collapsed}
                                onCollapse={onCollapse}
                                width={200}
                            >
                                <MainMenu />
                            </Sider>

                            <Content
                                style={{
                                    width: `100%`,
                                    height: `100%`,
                                    overflow: `hidden`,
                                    overflowY: `scroll`,
                                }}
                            >
                                <Routes>
                                    <Route path="/" element={<Profile />} />
                                    <Route
                                        path="/profile"
                                        element={<Profile />}
                                    />
                                    <Route
                                        path="/scores/enso"
                                        element={<ScoresEnso />}
                                    />
                                    <Route
                                        path="/scores/ai"
                                        element={<ScoresAi />}
                                    />
                                    <Route
                                        path="/favorites"
                                        element={<FavoritesRoute />}
                                    />
                                    <Route path="/mods" element={<Mods />} />
                                </Routes>

                                <div
                                    style={{
                                        fontSize: `12px`,
                                        textAlign: `right`,
                                        padding: `0 24px 24px`,
                                        color: `#a7a7a7`,
                                    }}
                                >
                                    {buildDate
                                        ? getBuildDateTimeString()
                                        : null}
                                </div>
                            </Content>
                        </Layout>
                    </GlobalProvider>
                </Layout>
            </Router>
        </div>
    );
}

export default App;
